import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-accordion-item',
    template: '',
})
export class AccordionItemComponent {
    @ContentChild('head', {static: false}) headImpl: TemplateRef<any>;
    @ContentChild('content', {static: false}) contentImpl: TemplateRef<any>;

    @Input() open = false;
}
